/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Form_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Caption Style Settings" |
*
* @param {Styles_Form_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_form_aria_label = /** @type {((inputs?: Styles_Form_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Form_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parametres de style de sous-titre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelstil-Einstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni stile didascalia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки стиля подписи")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración del estilo de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标题样式设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションスタイルの設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन शैली सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de estilo de legenda")
	return /** @type {LocalizedString} */ ("Caption Style Settings")
});